<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getReadiness, type HealthPayload } from '../api'

const health = ref<HealthPayload | null>(null)
const healthError = ref('')

onMounted(async () => {
  try {
    health.value = await getReadiness()
  } catch (error) {
    healthError.value = error instanceof Error ? error.message : 'unknown error'
  }
})
</script>

<template>
  <main>
    <div class="page-heading"><div><p class="label">SYSTEM</p><h2>运行总览</h2></div><button type="button" disabled>新建任务</button></div>
    <div class="metric-grid">
      <article><span>Go API</span><strong :class="health ? 'ok' : 'waiting'">{{ health?.data.status || '等待连接' }}</strong><small>{{ healthError || health?.data.version || '尚未部署' }}</small></article>
      <article><span>新数据库</span><strong>待创建</strong><small>shewobili_cc</small></article>
      <article><span>数据迁移</span><strong>0%</strong><small>基线准备中</small></article>
      <article><span>Cloudflare</span><strong>待授权</strong><small>已暴露 token 必须轮换</small></article>
    </div>
    <section class="panel"><h3>下一步</h3><ol><li>建立新 MySQL 数据库和最小权限用户</li><li>运行 migration</li><li>完成 catalog 全量同步 dry-run</li><li>用安全的新 token 创建两个 Pages 项目</li></ol></section>
  </main>
</template>

